module.exports = __webpack_public_path__ + "static/media/7up7down.8a63de9f.webp";